import * as React from 'react';

import { PlanType } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { Badge } from '~shared/components/Badge';
import {
  useCurrentPlan,
  useIsTrialing,
} from '~teacher/components/PricingTable/hooks';

/*
 * This badge is used to indicate the current Trial or Plan on the pricing table page
 */
export function PlanBadge({ targetPlan }: { targetPlan: PlanType }) {
  const isTrialingQuery = useIsTrialing();
  const currentPlanQuery = useCurrentPlan();

  const isUsingTrial = isTrialingQuery.data;
  const currentPlan = currentPlanQuery.data;

  if (isUsingTrial === undefined || currentPlan === undefined) {
    return null;
  }

  if (currentPlan !== targetPlan) {
    return null;
  }

  if (isUsingTrial) {
    return <Badge tone="info">{translate('YOUR TRIAL')}</Badge>;
  }

  return <Badge tone="info">{translate('YOUR PLAN')}</Badge>;
}
